import React, { TextareaHTMLAttributes } from 'react';

interface InputTextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {

}

const InputTextArea = (props: InputTextAreaProps) => {
    const { ...nativeProps } = props;
    return (
        <>
            <textarea className='textarea text-sm' {...nativeProps} />
        </>
    );
};

export default InputTextArea;